import { purpurBreakpointMd } from '@purpur/library/tokens';
import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { MenuItemBase, MenuItemIcon, MenuItemNamedIcon } from '../MenuItem/MenuItem.styles';

const SearchMenuItemBase = styled(MenuItemBase).attrs({ as: 'button', type: 'button' })``;

export const SearchOpenButton = styled(SearchMenuItemBase)`
    @media screen and (max-width: calc(${purpurBreakpointMd} - 1px)) {
        flex-direction: column;
        justify-content: center;
        gap: 0;
        font-size: ${getPurpurTypography('scale75')};

        ${MenuItemIcon},
        ${MenuItemNamedIcon} {
            width: ${getPurpurSpacing('300')};
            height: ${getPurpurSpacing('300')};
            margin-top: 0.375rem;
            margin-bottom: 0.375rem;
        }
    }
`;

export const SearchCloseButton = styled(SearchMenuItemBase)`
    display: none;
    margin-left: auto;

    ${purpurMedia('lg')`
        display: block;
    `};
`;
